import ApiService from "@/common/api.service";
import {
  FETCH_SPARE_PARTS,
  FETCH_SPARE_PART,
  UPDATE_SPARE_PART,
  CREATE_SPARE_PART,
  RESET_SPARE_PART,
  DELETE_SPARE_PART
} from "../actions.type";
import {
  FETCH_SPARE_PART_START,
  SET_SPARE_PARTS,
  SET_SPARE_PART
} from "../mutations.type";

const state = {
  spareParts: [],
  sparePartsCount: 1,
  sparePart: {},
  isLoading: false
};

const getters = {
  sparePartsCount: state => state.sparePartsCount,
  spareParts: state => state.spareParts,
  sparePart: state => state.sparePart,
  sparePartIsLoading: state => state.isLoading
};

const actions = {
  [FETCH_SPARE_PARTS]({ commit }, [filteringCriteria, search, filters]) {
    commit(FETCH_SPARE_PART_START);
    return ApiService.filteredCollection(
      "spare-parts",
      filteringCriteria,
      search,
      filters
    ).then(({ data }) => {
      commit(SET_SPARE_PARTS, data);
    });
  },
  [FETCH_SPARE_PART](context, id) {
    return ApiService.get("spare-parts", id).then(({ data }) => {
      context.commit(SET_SPARE_PART, data);
    });
  },
  [UPDATE_SPARE_PART](context, payload) {
    return ApiService.put(`spare-parts/${payload.id}`, payload);
  },
  [CREATE_SPARE_PART](context, payload) {
    return ApiService.post("spare-parts", payload);
  },
  [RESET_SPARE_PART](context) {
    context.commit(SET_SPARE_PART, {});
  },
  [DELETE_SPARE_PART](context, id) {
    return ApiService.delete("spare-parts", id);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_SPARE_PART_START](state) {
    state.isLoading = true;
  },
  [SET_SPARE_PARTS](state, data) {
    state.spareParts = data.items || [];
    state.sparePartsCount = data.total || 1;
    state.isLoading = false;
  },
  [SET_SPARE_PART](state, data) {
    state.sparePart = data;
    state.isLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
